// extracted by mini-css-extract-plugin
var _1 = "510px";
export { _1 as "maxTextualContentWidth" }
